import { render, staticRenderFns } from "./PermissionsDialog.vue?vue&type=template&id=391454ac&scoped=true&"
import script from "./PermissionsDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsDialog.vue?vue&type=style&index=0&id=391454ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391454ac",
  null
  
)

export default component.exports